<template>
  <mdb-container fluid v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '12px'}">
    <!--Section: Intro-->
    <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
      <strong>Contratistas de obra</strong>
    </h2>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div
            class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;"
          >
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Alta contratista</span>
                <a slot="reference" href="/createContractor">
                  <img
                    alt="alta contratista"
                    class="mt-0"
                    :src="imgServer+'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;"
                  />
                </a>
              </mdb-tooltip>
            </div>
            <span
              class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; margin-left: 10%;"
            >Contratistas registrados</span>

            <div class="text-right">

              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Reenviar código</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="ReSend"
                >
                  <mdb-icon far icon="paper-plane" class="mt-0"/>
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Editar contratista</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="editContractor">
                  <mdb-icon icon="pencil-alt" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
              <mdb-tooltip material trigger="hover" :options="{placement: 'top'}">
                <span slot="tip">Eliminar contratista</span>
                <mdb-btn
                  slot="reference"
                  outline="white"
                  rounded
                  size="sm"
                  class="px-2 button_background"
                  @click="removeContractor"
                >
                  <mdb-icon icon="trash" class="mt-0" />
                </mdb-btn>
              </mdb-tooltip>
            </div>
          </div>
          <!--/Card image-->

          <div class="px-4">
            <div class="table-responsive">
              <mdb-datatable
                :data="data"
                :borderless="true"
                responsive
                :tfoot="false"
                :arrows="true"
                :display="10"
                searchPlaceholder="Buscar"
                noFoundMessage="No se encontraron registros de contratistas"
                showingText="Mostrando"
                class="table table-responsive"
                id="dataTableBuilder"
              />
            </div>

            <!--Bottom Table UI-->
          </div>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->
  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardText,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbCardHeader,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable
} from "mdbvue";
import { send } from 'q';

export default {
  name: "Contractors",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardText,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbCardHeader,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable
  },
  data(){
    return{
        contractorSelected: [],
        urlServer: Servers.serverApi,
        imgServer: Servers.serverImg,
        data: {
        columns: [
          {
            label: "",
            field: "checkbox"
          },
          {
            label: "Nombre contratista",
            field: "name",
            sort: "asc"
          },
          {
            label: "Dirección",
            field: "address",
            sort: "asc"
          },
          {
            label: "Teléfono",
            field: "phone",
            sort: "asc"
          },
          {
            label: "Empresa",
            field: "company",
            sort: "asc"
          },
         /* {
            label: "",
            field: "rewrite",
            sort: "asc"
          }*/
        ],
        rows: []
      }
    };
  },
  methods:{
    ReSend(){
      let aux = this;
      aux.makeListOfContractors();
      if (aux.contractorSelected.length == 1) {
        aux.contractorSelected.map(function(value, key) {
         
            Swal.fire({
              title:
                "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas reenviar el acceso a este contratista?</span>",
              html:
                "<span style='font-size: 12px'>Se enviara un correo con las instrucciones para restablecer su acceso </span>",
              imageUrl: Servers.serverImg+"apps/myfrac/admin/assets/Alerta_icon@3x.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              }
            }).then(result => {
              if (result.value) {
                var data = value.email+"";
                Axios.post(
                  aux.urlServer + "api/users/resetPassword", data,
                  {
                    responseType: 'text',
                    headers: {
                    'Content-Type': 'text/plain',
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token")
                    }
                  }
                ).then(
                  function(response) {
                    aux.showMessageSucces("Correo enviado");
                  },
                  function(error) {
                    aux.showMessageError("Ha ocurrido un error", error.response.data);
                    return false;
                  }
                );
              }
            });
        });
      }
      else if (aux.contractorSelected.length == 0){
        aux.showMessageInfo("Es necesario seleccionar un contratista para poder reenviar el código.");
      } else {
         aux.showMessageInfo("No se puede reenviar el código a más de un contratista a la vez.");

      }
    },
  removeContractor(){
      let aux = this;
      aux.makeListOfContractors();
      if (aux.contractorSelected.length == 1) {
        aux.contractorSelected.map(function(value, key) {
         
            Swal.fire({
              title:
                "<span style='font-size: 16px; font-family: OpenSans-Regular;'>¿Seguro que deseas eliminar éste contratista?</span>",
              html:
                "<span style='font-size: 12px'>El contratista se eliminará permanentemente y sus accesos quedarán inhabilitados. </span>",
              imageUrl: Servers.serverImg+"apps/myfrac/admin/assets/Delete_Icon.png",
              imageWidth: "22%",
              imageHeight: "auto",
              width: "30%",
              showCancelButton: true,
              confirmButtonText: "Eliminar",
              cancelButtonText: "Cancelar",
              reverseButtons: true,
              customClass: {
                confirmButton: "btn-modal-accept",
                cancelButton: "btn-modal-cancel"
              }
            }).then(result => {
              if (result.value) {
                Axios.delete(
                  aux.urlServer + "api/contractors/" + value.uuid,
                  {
                    responseType: "application/json",
                    headers: {
                      Authorization:
                        "Bearer " + localStorage.getItem("access_token")
                    }
                  }
                ).then(
                  function(response) {
                    aux.showMessageSucces("Contratista eliminado correctamente");
                     window.location.reload();
                  },
                  function(error) {
                    aux.showMessageError("Ha ocurrido un error", error.response.data);
                    return false;
                  }
                );
              }
            });
        });
      }else if (aux.contractorSelected.length == 0){
        aux.showMessageInfo("Es necesario seleccionar un contratista para realizar la baja.");
      } else {
         aux.showMessageInfo("No se puede realizar la bajde de más de un contratista a la vez.");

      }
    

  },
  makeListOfContractors() {
      let aux = this;
      aux.contractorSelected = [];
      var arr = Array.prototype.slice.call(
        document.getElementsByClassName("form-check-input")
      );
      arr.map(function(value, key) {
        if (value.checked) {
          aux.contractorSelected.push({
            uuid: value.dataset.uuid,
            email: value.dataset.email
          });
        }
      });
  },
    editContractor(){
      let aux = this;
      aux.makeListOfContractors();
      if (this.contractorSelected.length == 1) {
          this.contractorSelected.map(function(value, key) {
               window.location.href = "./createContractor?token="+ value.uuid;
          });
      }
      else if (aux.contractorSelected.length == 0){
        aux.showMessageInfo("Es necesario seleccionar un contratista para realizar la edición.");
      } else {
         aux.showMessageInfo("No se puede editar a más de un contratista a la vez.");

      }
      
    },
    getContractors(){
      let aux = this;
      Axios.get(Servers.serverApi + "api/contractors/", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function(response) {
          response.data.map(function(value, key) {
            var object ={
              checkbox:
                '<input class="form-check-input" type="checkbox" id="contractor_' +
                value.uuid +
                '" data-uuid=' +
                value.uuid +
                " data-email=" +
                value.user.email+
                '><label for="contractor_' +
                value.uuid +
                '" class="label-table"></label>',
                name: value.firstName+' '+value.lastName,
                address: value.fullAddress,
                phone: value.phone,
                company: value.enterprise,
                /*rewrite: '<div class="tooltip-p">'+
                          '<input type="image" src="'+Servers.serverImg+'apps/myfrac/admin/assets/Share_BTN@3x.png" id="imgId" style="width: 17.5px;" data-email="'+value.user.email+'" class="img-fluid imgSend" >'+
                          '<span class="tooltiptext">Reenviar codigo</span>'+
                        '</div>'*/
            };
            aux.data.rows.push(object);
          });
        })
        .catch(error => {
          console.log(error.response);
          aux.showMessageError("Ha ocurrido un error", error.response.data);
        });
    },
    showMessageError: function(text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: Servers.serverImg+"/apps/myfrac/admin/assets/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {}
      });
    },
    showMessageSucces: function(text) {
      Swal.fire({
        title: "<span style='font-size: 20px;'>Correcto</span>",
        html: "<span style='font-size: 12px;'>" + text + "</span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () =>{
         
        }
      });
    },
    showMessageInfo: function(text){
       Swal.fire({
        title: "<span style='font-size: 14px;'>" + text + "</span>",
        type: "info",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
      });

    },

  },
   mounted() {
      this.getContractors();
     

  }       
};

</script>
<style scoped>


div.dataTables_wrapper div.dataTables_filter {
  float: left;
  margin-bottom: 0px;
}
.dataTableBuilder_filter label {
  display: none;
}

div.dataTables_wrapper div.dataTables_filter input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-bottom: 2rem;
  display: inline-block;
  width: 300px ;
  border-radius: 25px ;
  height: 15px ;
  padding-left: 35px ;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular" ;
  font-size: 12px ;
  color: #fff;
  background: url('../../../static/zoom_in.png')
    no-repeat scroll 12px 7px #67a3cf ;
  background-size: 20px 20px ;
}

div.dataTables_wrapper div.dataTables_length {
  display: none !important;
}

div.dataTables_wrapper div.dataTables_filter input[search]:focus {
  font-size: 12px;
}



div.dataTables_wrapper div.dataTables_filter input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff !important;
  opacity: 1; /* Firefox */
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}

div.dataTables_wrapper div.dataTables_filter input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #ffffff !important;
  font-size: 12px !important;
  padding-left: 0px !important;
  font-family: "OpenSans-Regular" !important;
}


div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
  position: absolute;
  top: 60px;
  font-family: "OpenSans-Light" !important;
  display: none !important;
}



table.dataTable tbody tr {
  background-color: #ffffff !important;
}


.dataTables_wrapper .dataTables_paginate .paginate_button.disabled {
  cursor: default;
  color: #666 !important;
  border-radius: 10px !important;
  background: transparent;
  box-shadow: none;
  font-family: "OpenSans-Light" !important;
  font-size: 12px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
  box-sizing: border-box;
  display: inline-block;
  min-width: 1.5em;
  margin-left: 2px;
  text-align: center;
  text-decoration: none !important;
  cursor: pointer;
  color: #333 !important;
  border: 1px solid transparent;
  border-radius: 5px;
  padding: 0px !important;
  margin-left: 14px !important;
}


.dataTables_wrapper .dataTables_paginate {
  width: 600px ;
  float: none ;
  margin: 0 auto ;
}

div.dataTables_paginate {
  display: block ;
  margin-left: auto ;
  margin-right: auto ;
  float: none ;
  text-align: center ;
}

#dataTableBuilder_previous > a,
#dataTableBuilder_next > a {
  height: 30px !important;
}


.md-form input[type="search"]:focus:not([readonly]) {
  -webkit-box-shadow: 0 0px 0 0 transparent !important;
  box-shadow: unset;
  border-bottom: unset;
  outline: none !important;
}

.searchIcon {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 999;
  top: 16px;
  left: 26px;
}

.searchIcon img {
  width: 100%;
  height: auto;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.pagination > .active > a, 
.pagination > .active > span {
  z-index: 3;
  color: #999;
  cursor: default;
  background-color: #67a3cf !important;
  border-color: #707070 !important;
}
.paginate_button {
  background: #f6f6f6 !important;
}



.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 2px solid #f6f6f6;
  font-family: "OpenSans-Regular" !important;
  font-size: 12px;
  color: #000000 !important;
}
.table > thead:first-child > tr:first-child > th {
  border-top: 0;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center;
}





.table > thead > tr > th:nth-child(1) > .sorting{
  display: none !important;
}
.table > tbody > tr > td:nth-child(3) {
  text-align: left !important;
}
.table > tbody > tr > td:nth-child(1) {
  text-align:right !important;
}
.table > thead > tr > th:nth-child(3){
  text-align: left !important;
}
.table > thead > tr > th:nth-child(4){
  text-align: left !important;
}


</style>